<template>
  <div class="audio-wrap" id="audio-player">
    <audio
      id="my-audio"
      @play="playAudio"
      controls
      ref="audioRef"
      class="audio_class"
      :muted="true"
    >
      <source :src="audioData.url" type="audio/mpeg" />
      您的浏览器不支持音频播放
    </audio>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    audioData: {
      type: Object,
      default() {
        return {
          url: '',
          length: 0, // 毫秒
          blob: null,
          uid: null,
        }
      },
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value: 0,
      duration: 0,
    }
  },
  computed: {},
  watch: {},
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      const recordAudio = this.$refs.audioRef
      recordAudio.muted = false
      // recordAudio.play().then(() => recordAudio.pause())
      recordAudio.currentTime = 0
    })
  },
  methods: {
    // 播放暂停控制
    playAudio() {
      this.$emit('play', this.id)
    },
    pauseAudio() {
      const recordAudio = this.$refs.audioRef
      recordAudio.pause()
    },
  },
}
</script>
<style lang="scss" scoped>
.audio-wrap {
  height: 30px;
  position: relative;
  margin: 5px 0px;
  display: flex;
  align-items: center;
}
.audio_class {
  border-radius: 0px !important;
  width: 638px;
  height: 35px;
}
</style>
